import {MultiSelectItem} from '../interfaces/multi-select-item';
import {Subject} from 'rxjs';
export class MultiSelect {

  multiSelectData: Array<MultiSelectItem>;
  selectionChange: Subject<MultiSelectItem> = new Subject<MultiSelectItem>();

  constructor(multiSelectData: Array<MultiSelectItem>) {
    this.multiSelectData = multiSelectData;
  }
}
